// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenCategorie } from '../model/collectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenCategorie.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Antwoorden worden als Markdown teruggegeven en moeten door de client veilig worden gerenderd.
 * @summary Haalt actieve veelgestelde vragen per categorie op.
 */
export const veelgesteldeVragenGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfCrmVeelgesteldeVragenGetVeelgesteldeVragenCategorie>(
    { url: `/api/v1/veelgestelde-vragen`, method: 'GET', signal },
    options,
  );
};

export const getVeelgesteldeVragenGetQueryKey = () => {
  return ['api', 'v1', 'veelgestelde-vragen'] as const;
};

export const getVeelgesteldeVragenGetQueryOptions = <
  TData = Awaited<ReturnType<typeof veelgesteldeVragenGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof veelgesteldeVragenGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getVeelgesteldeVragenGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof veelgesteldeVragenGet>>> = ({ signal }) =>
    veelgesteldeVragenGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof veelgesteldeVragenGet>>,
    TError,
    TData
  >;
};

export type VeelgesteldeVragenGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof veelgesteldeVragenGet>>
>;
export type VeelgesteldeVragenGetQueryError = ErrorType<unknown>;

/**
 * @summary Haalt actieve veelgestelde vragen per categorie op.
 */

export function useVeelgesteldeVragenGet<
  TData = Awaited<ReturnType<typeof veelgesteldeVragenGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof veelgesteldeVragenGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getVeelgesteldeVragenGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
